window.__tnt || (window.__tnt = {});
window.__tnt.pay || (window.__tnt.pay = {});

window.__tnt.pay.initPromises = [];
window.__tnt.pay.initialized = false;

window.__tnt.pay.method || (window.__tnt.pay.method = {});

/* tntPayment, runs when the form has initialized */
window.tntPayment = document.createEvent('Event');
tntPayment.initEvent('tnt-payment',true,true,{});

window.tntPaymentSubmitted = document.createEvent('Event');
tntPaymentSubmitted.initEvent('tnt-payment-submitted', true, true, {});

window.tntPaymentError = document.createEvent('Event');
tntPaymentError.initEvent('tnt-payment-error', true, true, {});

/* Handle messages passed from payment iframe */
window.addEventListener('message', function(ev){
    var paymentFrameElements = document.querySelectorAll('iframe.spp-payment-frame');

    if (ev.data?.type == "SPREEDLY_TOKEN" && ev.data.token) {
        if(paymentFrameElements) {
            paymentFrameElements.forEach(frame => {
                if (frame.dataset.paymentType = "spp") {
                    var frameContentWindow = frame.contentWindow,
                        pf = null;

                    if (frame.dataset.paymentForm) pf = document.getElementById(frame.dataset.paymentForm);

                    if (pf && frame.contentWindow === ev.source) {
                        const data = new URLSearchParams();

                        data.append('tnpay-token', ev.data.token.token);
                        data.append('tnpay-year', ev.data.token.year);
                        data.append('tnpay-month', ev.data.token.month);
                        data.append('tnpay-last4', ev.data.token.last_four_digits);
                        data.append('tnpay-name', ev.data.token.full_name);

                        __tnt.pay.handlePurchaseSubmit(pf, data);
                    }
                }
            });
        }
    } else if (ev.data?.type == 'FORM_VALIDATION') {
        if (paymentFrameElements) {
            paymentFrameElements.forEach(frame => {
                if (frame.contentWindow === ev.source) {
                    if (ev.data.isValid) {
                        frame.dataset.isValid = "true";
                        __tnt.subscription.offers.logPaymentInfoEntered({
                            step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                            paymentMethod: __tnt.pay.method.newCard.methodString
                        });
                    } else {
                        frame.dataset.isValid = "false";
                    }

                    var pf = null;
                    if (frame.dataset.paymentForm) pf = document.getElementById(frame.dataset.paymentForm);
                    if (pf) __tnt.pay.tntTosEnableSubmit(pf);
                }
            });
        }

    } else if (ev.data?.type == 'SPREEDLY_ERROR') {
        paymentFrameElements.forEach(frame => {
            if (frame.contentWindow === ev.source) {
                var pf = null,
                    errorEl = null,
                    errorMessageEl = null;

                if (frame.dataset.paymentForm) pf = document.getElementById(frame.dataset.paymentForm);

                if (pf && pf.dataset.errorElement) errorEl = document.getElementById(pf.dataset.errorElement);

                if (errorEl) {
                    errorMessageEl = errorEl.querySelector('.error-message');
                    
                    if (errorMessageEl) {
                        errorMessageEl.innerText = '';
                    
                        ev.data.errors.forEach(error => {
                            console.error(error.message);
                            
                            var errorOutput = document.createElement('div');
                            
                            errorOutput.innerText = error.message;
                            errorMessageEl.append(errorOutput);
                        });
                    }
                    
                    errorEl.classList.remove('fade');
                    errorEl.hidden = false;
                    errorEl.scrollIntoView({block:'center'});
                }
            }
        });
    } else if (ev.data?.type == 'FRAME_HEIGHT') {
        paymentFrameElements.forEach(frame => {
            if (frame.contentWindow === ev.source) {
                frame.style.height = ev.data.height + 'px';
            }
        });
    }
});

/*
 * Clear Selected Payment Method
 *
 * @DESC Resets the users payment method selections
 */
__tnt.pay.clearPaymentMethod = function(pf){
    if(pf){
        var payMethodElement = pf.querySelector('.tn-pay-method-output'),
            payMethodAltElement = pf.querySelector('.tn-pay-method-alt'),
            payMethodNewCard = pf.querySelector('.tn-pay-method-new-card'),
            selectedPayMethods = null,
            selectedAltPayMethods = null;
         
        if (payMethodElement) { 
            selectedPayMethods = payMethodElement.querySelectorAll('.wallet-btn');
                
            if (selectedPayMethods) { selectedPayMethods.forEach(function(selectedPayMethod){ selectedPayMethod.classList.remove('tn-pay-method-selected') }) }
        }
            
        if (payMethodAltElement) {
            selectedAltPayMethods = payMethodAltElement.querySelectorAll('.wallet-btn');
    
            if (selectedAltPayMethods) { selectedAltPayMethods.forEach(function(selectedAltPayMethod){ selectedAltPayMethod.classList.remove('tn-pay-method-selected') }) }
        }
            
        if (payMethodNewCard) { payMethodNewCard.classList.remove('tn-pay-method-selected') }
        
        if (pf.dataset.paymentMethod) {
            pf.removeAttribute('data-payment-method');
        }

        if(pf['tnpay-token']) pf['tnpay-token'].value = "";
        if(pf['use_stored']) pf['use_stored'].value = "";
    }
}

/*
 * Update display of Payment Methods
 * 
 * @DESC shows / hides the pay card entry if multiple payment options are available
 */
__tnt.pay.updatePaymentMethodDisplay = function(pf) {
    if (pf) {
        var payMethodElement = pf.querySelector('.tn-pay-method-output'),
            payMethodSelect = pf.querySelector('.tn-pay-method-select'),
            payMethodAltElement = pf.querySelector('.tn-pay-method-alt'),
            payCardEntry = pf.querySelector('.tn-pay-card-entry');

        if (
            ((payMethodElement && payMethodElement.querySelector('.wallet-btn')) || 
            (payMethodAltElement && payMethodAltElement.querySelector('.wallet-btn'))) &&
            payCardEntry
        ){
            payMethodSelect.hidden = false;
            payCardEntry.hidden = true
        } else if (payCardEntry) {
            payMethodSelect.hidden = true;
            payCardEntry.hidden = false

        }
    }
}

/*
 * Set Payment Method
 *
 * @DESC Set the method being used to pay
 */
__tnt.pay.setPaymentMethod = function(pf, methodName, methodButtonElement, tokenData){
    __tnt.pay.clearPaymentMethod(pf);

    try {
        var cardEntry = null;

        if (pf) {
            __tnt.pay.clearPaymentMethod(pf);

            cardEntry = pf.querySelector('.tn-pay-card-entry');
        }

        if (pf && methodName) pf.dataset.paymentMethod = methodName;

        if(tokenData && tokenData.id) {
            if(pf['tnpay-token']) pf['tnpay-token'].value = tokenData.id;
            if(pf['use_stored']) pf['use_stored'].value = true;
        }

        if (methodButtonElement) {
            var paymentMethodEventLabel = methodButtonElement.dataset.paymentMethodEventLabel;
            __tnt.subscription.offers.setPaymentMethodString(paymentMethodEventLabel);

            __tnt.pay.logPaymentMethodChange(paymentMethodEventLabel);

            methodButtonElement.classList.add('tn-pay-method-selected');
            methodButtonElement.dispatchEvent(new CustomEvent('BLOXPaymentMethodSet', { detail: { 'paymentMethod': paymentMethodEventLabel } }));
        }
        if (cardEntry && methodButtonElement && !methodButtonElement.classList.contains('tn-pay-method-new-card')) cardEntry.hidden = true;
    } catch(error){
        console.error('Unable to set payment method', error);

        window.dispatchEvent(new CustomEvent('BLOXException', { 
            'bubbles': true,
            'detail': {
                'description': "Unable to set payment method",
                'fatal': false,
                'error_code': "CantSetPayMethod",
                'category': "subscription"
            }
        }));
    }

    __tnt.pay.tntTosEnableSubmit(pf);
}

/*
 * Log Payment Method Change
 *
 * @DESC Log when the user changes their payment method
 */
__tnt.pay.logPaymentMethodChange = function(paymentMethodEventLabel) {
    if (paymentMethodEventLabel) {
        __tnt.subscription.offers.logCheckoutStepViewed({
            step: __tnt.subscription.offers.getPurchaseStep('selected_payment_method'),
            label: 'Selected payment method',
            paymentMethod: paymentMethodEventLabel
        });
        __tnt.subscription.offers.logCheckoutStepCompleted({
            step: __tnt.subscription.offers.getPurchaseStep('selected_payment_method'),
            label: 'Selected payment method',
            paymentMethod: paymentMethodEventLabel
        });
    }
}

/*
 * Validate Form
 *
 * @DESC Should observe the relevant required form inputs and inform the user when something is wrong
 */
__tnt.pay.validateForm = function(pf){
    /* if form validation has not yet been set up, set up form validation */
    if (pf && !pf.classList.contains('has-form-validation')) {
        pf.classList.add('has-form-validation');

        $(pf).validate({
            onkeyup: false,
            errorClass: 'has-error text-danger',
            errorElement: 'span',
            validClass: 'has-success text-success',
            highlight: function(element, errorClass, validClass) {
                $(element).parents('.form-group').addClass(errorClass).removeClass(validClass);
            },
            unhighlight: function(element, errorClass, validClass) {
                $(element).parents('.form-group').removeClass(errorClass).addClass(validClass);
            },
            rules: {
                password_verify: {
                    equalTo: pf.password,
                    hasSequentialNumbers: true,
                    hasRepeatingChars: true,
                    minlength: 8
                }
            },
            messages: {
                password_verify: {
                    equalTo: "The password you entered doesn't match.",
                    minlength: "Passwords must be at least 8 characters long."
                }
            }
        });

    /* if form validation has been initialized, reset the plugin and clear any errors */
    } else if (pf && pf.classList.contains('has-form-validation')) {
        $(pf).validate().resetForm();

        var hasErrors = pf.querySelectorAll('.has-error');

        if(hasErrors){
            hasErrors.forEach(function(errorEl){
                errorEl.classList.remove('has-error');
                errorEl.classList.remove('text-danger');
            });
        }
    }
}

/* 
 * Get Location
 *
 * @DESC checks the location information and sets tax data
 */
__tnt.pay.getLocation = function(oForm){
// Gather location inputs
    var paymentZip = oForm.querySelector('input[name=postal_code]'),
        billLocState = oForm.querySelector('select[name=postal-state]'),
        billLocZip = oForm.querySelector('input[name=postal-postcode]'),
        billLocCountry = oForm.querySelector('select[name=postal-country]'),
        billLocAddress = oForm.querySelector('input[name=postal-address]'),
        billLocCity = oForm.querySelector('input[postal-city]');

    try {
        if (typeof paymentZip === 'undefined') {
            // Create hidden postal_code input
            var paymentZip = document.createElement('input');
            
            paymentZip.setAttribute('type', 'hidden');
            paymentZip.setAttribute('name', 'postal_code');
            paymentZip.setAttribute('value', billLocZip.value);

            oForm.appendChild(paymentZip);
        } else if (!paymentZip.value || paymentZip.value == null) {
            // Populate empty postal_code input
            paymentZip.value = billLocZip.value;
        } 
    } catch(e) { console.log(e) }

    try {
        // Ensure purchaser inputs are supplied for gift transactions
        if (oForm.dataset.purchaseType == 'gift') {
            // Get purchaser inputs
            let purchaserState = oForm.querySelector('input[name=purchaser_state]'),
                purchaserZip = oForm.querySelector('input[name=purchaser_zip]'),
                purchaserCountry = oForm.querySelector('input[name=purchaser_country]'),
                purchaserAddress = oForm.querySelector('input[name=purchaser_address]'),
                purchaserCity = oForm.querySelector('input[name=purchaser_city]');

            // Create hidden purchaser input fields if they don't exist
            if (purchaserState === null) {
                purchaserState = document.createElement('input');

                purchaserState.setAttribute('type', 'hidden');
                purchaserState.setAttribute('name', 'purchaser_state');
                purchaserState.value = billLocState.value;

                oForm.appendChild(purchaserState);
            }

            if (purchaserZip === null) {
                purchaserZip = document.createElement('input');

                purchaserZip.setAttribute('type', 'hidden');
                purchaserZip.setAttribute('name', 'purchaser_zip');
                purchaserZip.value = billLocZip.value;

                oForm.appendChild(purchaserZip);
            }

            if (purchaserCountry === null) {
                purchaserCountry = document.createElement('input');

                purchaserCountry.setAttribute('type', 'hidden');
                purchaserCountry.setAttribute('name', 'purchaser_country');
                purchaserCountry.value = billLocCountry.value;

                oForm.appendChild(purchaserCountry);
            }

            if (purchaserAddress === null) {
                purchaserAddress = document.createElement('input');

                purchaserAddress.setAttribute('type', 'hidden');
                purchaserAddress.setAttribute('name', 'purchaser_address');
                purchaserAddress.value = billLocAddress.value;

                oForm.appendChild(purchaserAddress);
            }

            if (purchaserCity === null) {
                purchaserCity = document.createElement('input');

                purchaserCity.setAttribute('type', 'hidden');
                purchaserCity.setAttribute('name', 'purchaser_city');
                purchaserCity.value = billLocCity.value;

                oForm.appendChild(purchaserCity);
            }
        }
    } catch(e) { console.log(e) }
}

/*
 * Enable Submit Button
 *
 * @DESC toggles the submit button based on the TOS checkmark
 */
__tnt.pay.tntTosEnableSubmit = function(pf){
    var tos = null,
        paymentButton = null;

    if (pf) {
        tos = document.getElementById(pf.dataset.termsOfService);
        paymentButton = document.getElementById(pf.dataset.submitButton);
    }

    if (tos && tos.checked) {
        if (paymentButton) {
            paymentButton.disabled = false;
        }

        __tnt.subscription.offers.logCheckoutStepViewed({
            step: __tnt.subscription.offers.getPurchaseStep('tos'),
            label: 'Agreed to terms of service'
        });
        __tnt.subscription.offers.logCheckoutStepCompleted({
            step: __tnt.subscription.offers.getPurchaseStep('tos'),
            label: 'Agreed to terms of service'
        });
    } else if (paymentButton) {
        paymentButton.disabled = true;
    }
}

/*
 * Enable Form for Known User
 *
 * @DESC Modifies display of the purchase form and federated authentication form based on user status
 */
__tnt.pay.enableFormForKnownUser = function(pf, tntPay) {
    var pfLogin = pf.querySelector('.tnt-purchase-login'),
        afWrapper = tntPay.querySelector('.tnt-payment-federated-auth'),
        modalEl = document.getElementById('access-offers-modal'),
        modalDialogContainer = null,
        activeTab = null;

    if (pf) {
        pf.classList.remove("not-logged-in-form-disabled");
        pf.hidden = false;
    }

    if(afWrapper){ afWrapper.hidden = true }

    if(modalEl){
        modalDialogContainer = modalEl.querySelector('.modal');

        if(modalDialogContainer && modalDialogContainer.classList.contains('in')){
            activeTab = modalDialogContainer.querySelector('.modal-content.active');

            if(activeTab){
                activeTab.classList.remove('modal-scrollable');
                activeTab.removeAttribute('data-scrollable');
            }
        }

        window.dispatchEvent(new CustomEvent('tnt-show-offer-modal-tab', {
            'bubbles': true,
            'detail': {
                'tab': activeTab,
                'resizeTab': true
            }
        }));
    }
}

/*
 * Clear Federated Authentication
 *
 * @DESC clears any values entered into the federated authentication form
 */ 
__tnt.pay.clearFederatedAuth = function(af){
    if (af && af.email) {
        af.email.value = "";
    }
}

/*
 * User Selected to Continue with Email
 *
 * @DESC Uses data from the federated authentication form to populate the purchase form
 */
__tnt.pay.selectedContinueWithEmail = function(pf, af, tntPay) {
    var emailAddressEl = af.querySelector('input[name=email]'),
        emailAddress = "";

    if(emailAddressEl){ emailAddress = emailAddressEl.value }

    if(emailAddress != ""){
        pf.querySelector('input[name=email]').value = emailAddress;
        pf.dataset.continueWithEmail = 'true';
        __tnt.pay.enableFormForKnownUser(pf, tntPay);
    }
    
    return false;
};

/*
 * Handle Purchase Form Submit
 * 
 * @DESC Handles submission of the payment form
 */
__tnt.pay.handlePurchaseSubmit = function (pf, oData) {

    try {
        // Set location fields
        __tnt.pay.getLocation(pf);

        // Endpoint
        var purchaseEndpoint = pf.action;

        grecaptcha.enterprise.ready(function(){
            grecaptcha.enterprise.execute(pf.dataset.captchaKey, {action: 'subscribe'}).then(function(vkToken){
                if (!oData) oData = new URLSearchParams();

                oData.append('recaptcha_token', vkToken);

                for (const aPair of new FormData(pf)) {
                    if (!oData.has(aPair[0])) oData.append(aPair[0], aPair[1]);
                }

                tntPaymentSubmitted.detail = {};
                pf.dispatchEvent(tntPaymentSubmitted);

                fetch(purchaseEndpoint, {
                    method: 'post',
                    credentials: 'include',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: oData
                }).then(function(oResp){
                    oPayload = oResp.json().then(function(oPayload){
                        if (oPayload.transaction_id || (pf.dataset.purchaseType == "gift" && oPayload.success == true)){
                            var oProductData = __tnt.subscription.offers.getProduct(),
                                date = new Date();

                            const successDetails = {
                                payload: oPayload,
                                transactionData: {
                                    transaction_id: oPayload.transaction_id,
                                    start_date: date.getTime(),
                                    tax: Number(oPayload.tax_assessed / 100), // normalizing to dollars since the server response is in cents
                                    purchaseType: pf.dataset.purchaseType
                                }
                            };

                            if (oProductData) {
                                successDetails.transactionData.service_name = oProductData.name;
                                successDetails.transactionData.service_rate = oProductData.variant;
                                successDetails.transactionData.rate_price = oProductData.price;
                                successDetails.transactionData.currency = oProductData.currency;
                            } else {
                                console.warn("Product data not found");
                            }

                            const tntPaymentSuccess = new CustomEvent('tnt-payment-success', {
                                bubbles: true,
                                cancelable: true,
                                detail: successDetails
                            });

                            pf.dispatchEvent(tntPaymentSuccess);
                            
                            /* LOG PURCHASE COMPLETE EVENT */
                            __tnt.subscription.offers.logOrderCompleted(oPayload.transaction_id);

                        } else if (oPayload.success) {
                            pf.dispatchEvent(
                                new CustomEvent('tnt-payment-success', {
                                    bubbles: true,
                                    cancelable: true,
                                    detail: {
                                        payload: oPayload
                                    }
                                })
                            );

                        } else {
                            tntPaymentError.detail = {};

                            if (oPayload.success && oPayload.message == "Payment method added and Transaction updated"){
                            } else {
                                var message = "An error occurred";

                                if (oPayload.message) {
                                    tntPaymentError.detail.message = oPayload.message;
                                    message += ": " + oPayload.message;
                                }

                                if (oPayload.original_rate && oPayload.resolved_rate) {
                                    tntPaymentError.detail.requires_confirmation = true;
                                    tntPaymentError.detail.original_rate = oPayload.original_rate;
                                    tntPaymentError.detail.resolved_rate = oPayload.resolved_rate;
                                }

                                var httpStatus = null;
                                if (oResp.status) httpStatus = oResp.status;

                                var httpStatusFatal = false;
                                if (oResp.status > 499) httpStatusFatal = true;

                                window.dispatchEvent(new CustomEvent('BLOXException', {
                                    'bubbles': true,
                                    'detail': {
                                        'description': message,
                                        'http_status': httpStatus,
                                        'fatal': httpStatusFatal,
                                        'error_code': "PayloadFailure",
                                        'category': "subscription",
                                        'payment_method': __tnt.pay.method.newCard.name,
                                        'payment_gateway': null,
                                        'ecommerce_channel': 'subscription'
                                    }
                                }));

                                pf.dispatchEvent(tntPaymentError);
                            }
                        }
                    }).catch(function(error){
                        console.error(error);

                        tntPaymentError.detail = {};
                        tntPaymentError.detail.message = "An error occurred";
                        var message = "Error getting response data";
                        if (error && error.message) message += ": " + error.message;

                        var httpStatus = null;
                        if (oResp.status) httpStatus = oResp.status;

                        var httpStatusFatal = false;
                        if (oResp.status > 499) httpStatusFatal = true;

                        window.dispatchEvent(new CustomEvent('BLOXException', { 
                            'bubbles': true,
                            'detail': {
                                'description': message,
                                'http_status': httpStatus,
                                'fatal': httpStatusFatal,
                                'error_code': "ResponseError",
                                'category': "subscription",
                                'payment_method': __tnt.pay.method.newCard.name,
                                'payment_gateway': null,
                                'ecommerce_channel': 'subscription'
                            }
                        }));

                        pf.dispatchEvent(tntPaymentError);
                    });
                }).catch(function(error){
                    console.error(error);

                    tntPaymentError.detail = {};
                    tntPaymentError.detail.message = "An error occurred";

                    var message = "An error occurred";
                    if (error && error.message) message += ": " + error.message;

                    window.dispatchEvent(new CustomEvent('BLOXException', {
                        'bubbles': true,
                        'detail': {
                            'description': message,
                            'http_status': null,
                            'fatal': false,
                            'error_code': "FetchError",
                            'category': "subscription",
                            'payment_method': __tnt.pay.method.newCard.name,
                            'payment_gateway': null,
                            'ecommerce_channel': 'subscription'
                        }
                    }));

                    pf.dispatchEvent(tntPaymentError);
                });

            }).catch(function(error){
                console.error(error);

                tntPaymentError.detail = {};

                tntPaymentError.detail.message = "An error occurred";

                var message = "An error occurred";
                if (error && error.message) message += ": " + error.message;

                window.dispatchEvent(new CustomEvent('BLOXException', {
                    'bubbles': true,
                    'detail': {
                        'description': message,
                        'http_status': null,
                        'fatal': false,
                        'error_code': "GrecaptchaError",
                        'category': "subscription",
                        'payment_method': __tnt.pay.method.newCard.name,
                        'payment_gateway': null,
                        'ecommerce_channel': 'subscription'
                    }
                }));

                pf.dispatchEvent(tntPaymentError);
            });

        });
    } catch (error) {
       console.error(error);

        tntPaymentError.detail = {};
        tntPaymentError.detail.message = "An error occurred"; 
        var message = "An error occurred";
        if (error && error.message) message += ": " + error.message;

        window.dispatchEvent(new CustomEvent('BLOXException', {
            'bubbles': true,
            'detail': {
                'description': message,
                'http_status': null,
                'fatal': false,
                'error_code': "GeneralPaymentError",
                'category': "subscription",
                'payment_method': __tnt.pay.method.newCard.name,
                'payment_gateway': null,
                'ecommerce_channel': 'subscription'
            }
        }));

        pf.dispatchEvent(tntPaymentError);
    }

};

/*
 * Register Credit Card Payments
 */
__tnt.pay.method.newCard = {
    name: "newCard",
    methodString: "Credit Card",
    init: function(pf) {
        var addNewCardEl = pf.querySelector('.tn-pay-method-new-card'),
            cardEntryEl = pf.querySelector('.tn-pay-card-entry'),
            cardWidgetWrapper = pf.querySelector('.tn-pay-card-wrapper'),
            cardDataSource = "";

        if (pf.dataset.cardsSource) cardDataSource = pf.dataset.cardsSource;

        if(addNewCardEl && cardEntryEl){
            addNewCardEl.dataset.paymentMethodEventLabel = __tnt.pay.method.newCard.methodString;
            addNewCardEl.addEventListener('click', function(ev){
                __tnt.pay.clearPaymentMethod(pf);

                pf.removeAttribute('data-payment-method');
                if (pf.dataset.cardEndpoint) pf.action = pf.dataset.cardEndpoint;
                
                cardEntryEl.hidden = false;

                __tnt.pay.logPaymentMethodChange(__tnt.pay.method.newCard.methodString);
                __tnt.subscription.offers.setPaymentMethodString(__tnt.pay.method.newCard.methodString);

                addNewCardEl.classList.add('tn-pay-method-selected');
            });
        }

        if (cardWidgetWrapper) {
            cardWidgetWrapper.innerHTML = "";

            var pif = document.createElement('iframe');

            pif.src = "/tncms/pay/add_card/?handler=" + cardDataSource + "&style=flex-spp";
            pif.width = "100%";
            pif.scrolling = "no";
            pif.frameborder = "0";
            pif.style = "overflow: hidden; min-height: 187px;"
            pif.className = "spp-payment-frame";
            pif.dataset.paymentForm = pf.id;
            pif.dataset.paymentType = "spp";

            cardWidgetWrapper.appendChild(pif);
        }
    },
    submitPayment: function(pf) {
        var pif = pf.querySelector('iframe.spp-payment-frame'),
            pifw = null;

        if (pif) {
            pifw = pif.contentWindow;

            if (pifw) {
                pifw.postMessage({"action":"tokenize"});
            }
        }
    }
};

document.addEventListener("DOMContentLoaded", function (event) {
    var tntPaymentWrapper = document.querySelectorAll('.tnt-payment');

    if(tntPaymentWrapper && tntPaymentWrapper.length){

        tntPaymentWrapper.forEach(function(tntPay){

            /* Payment Form Setup */
            var pf = tntPay.querySelector('form.tnt-payment-form'),
                af = tntPay.querySelector('form.tnt-payment-federated-auth-form'),
                tos = null,
                paymentButton = null,
                copyToggle = null,
                afEmail = null,
                pfEmail = null,
                pfName = null,
                pfDelivery = null;

            /* Payment Form */
            if(pf){
                tos = pf.tos_confirm;
                paymentButton = pf.payment_button;
                copyToggle = pf.querySelector('.same-info');

                if(__tnt.user.authToken == null && pf.dataset.purchaseType != "gift"){
                    pf.classList.add("not-logged-in-form-disabled");

                    if (pf.email) pf.email.required = true;
                    if (pf.password) pf.password.required = true;
                    if (pf.password_verify) pf.password_verify.required = true;
                } else {
                    if (pf.email) pf.email.required = false;
                    if (pf.password) pf.password.required = false;
                    if (pf.password_verify) pf.password_verify.required = false;

                    __tnt.pay.enableFormForKnownUser(pf, tntPay);
                }

                /* Payment Form Validation */
                __tnt.pay.validateForm(pf);

                /* automatically copy location information */
                if (copyToggle) {
                    copyToggle.addEventListener("change", function(event){
                        if(event.target.checked){
                            var billingForm = pf.querySelector('.tnt-billing-location'),
                                billingFormAddress = null,
                                billingFormCity = null,
                                billingFormState = null,
                                billingFormCountry = null,
                                billingFormPostalCode = null,
                                deliveryForm = pf.querySelector('.tnt-delivery-location'),
                                deliveryFormAddress = null,
                                deliveryFormCity = null,
                                deliveryFormState = null,
                                deliveryFormCountry = null,
                                deliveryFormPostalCode = null,
                                deliveryFormPhone = null;

                            if(billingForm && deliveryForm){
                                try {
                                    billingFormAddress = billingForm.querySelector('input[name="postal-address"]');
                                    deliveryFormAddress = deliveryForm.querySelector('input[name=address]');
                                
                                    if (billingFormAddress && deliveryFormAddress) deliveryFormAddress.value = billingFormAddress.value;
                                    if (deliveryFormAddress) __tnt.subscription.offers.locationInputLengths.address = deliveryFormAddress.value.length;
                                    
                                    billingFormCity = billingForm.querySelector('input[name="postal-city"]');
                                    deliveryFormCity = deliveryForm.querySelector('input[name=municipality]');
                                    
                                    if (billingFormCity && deliveryFormCity) deliveryFormCity.value = billingFormCity.value;
                                    if (deliveryFormCity) __tnt.subscription.offers.locationInputLengths.municipality = deliveryFormCity.value.length;
                                } catch (e) { 
                                    console.warn("Address, city not collected");
                                }

                                try {
                                    billingFormState = billingForm.querySelector('select[name="postal-state"]');
                                    deliveryFormState = deliveryForm.querySelector('select[name=region]');

                                    if (billingFormState && deliveryFormState) deliveryFormState.value = billingFormState.value;
                                    if (deliveryFormState) __tnt.subscription.offers.locationInputLengths.region = deliveryFormState.value.length;

                                    billingFormCountry = billingForm.querySelector('select[name="postal-country"]');
                                    deliveryFormCountry = deliveryForm.querySelector('select[name=country]');

                                    if (billingFormCountry && deliveryFormCountry) deliveryFormCountry.value = billingFormCountry.value;
                                    if (deliveryFormCountry) __tnt.subscription.offers.locationInputLengths.country = deliveryFormCountry.value.length
                                    
                                    billingFormPostalCode = billingForm.querySelector('input[name="postal-postcode"]');
                                    deliveryFormPostalCode = deliveryForm.querySelector('input[name=postal_code]');
                                    
                                    if (billingFormPostalCode && deliveryFormPostalCode) deliveryFormPostalCode.value = billingFormPostalCode.value;
                                    if (deliveryFormPostalCode) __tnt.subscription.offers.locationInputLengths.postal_code = deliveryFormPostalCode.value.length;

                                    deliveryFormPhone = deliveryForm.querySelector('input[name=phone]');
                                    if (deliveryFormPhone) __tnt.subscription.offers.locationInputLengths.phone = deliveryFormPhone.value.length;
                                
                                } catch (e) { 
                                    console.warn("Unable to copy location information");
                                }
        
                                /** Run tax calculation */
                                __tnt.subscription.offers.calculateTax(pf, pf.postal_code, pf.country);

                                if (__tnt.subscription.offers.locationInputsEntered()) {
                                    __tnt.subscription.offers.logCheckoutStepCompleted({
                                        step: __tnt.subscription.offers.getPurchaseStep('location'),
                                        label: 'Location information defined'
                                    });
                                }
                            }
                        }
                    });
                }
                
                /* Checkout Step - entering the email */
                pfEmail = pf.querySelector('input[name="email"]');
                if (pfEmail) {
                    pfEmail.addEventListener('focus', function(ev) {
                        __tnt.subscription.offers.logCheckoutStepViewed({
                            step: __tnt.subscription.offers.getPurchaseStep('email'),
                            label: 'Entering email address'
                        });
                    });

                    pfEmail.addEventListener('blur', function(ev) {
                        if (pfEmail.value) {
                            __tnt.subscription.offers.logCheckoutStepCompleted({
                                step: __tnt.subscription.offers.getPurchaseStep('email'),
                                label: 'Email address defined'
                            });
                        }
                    });
                }

                /* Checkout Step - entering the delivery location */
                pfDelivery = pf.querySelector('.delivery-location-required');
                if (pfDelivery) {
                    var locationFields = pfDelivery.querySelectorAll('input[type=text], input[type=tel], select');
                    locationFields.forEach(function(el) {
                        // Set lengths for inputs that are pre-filled
                        if (el.value.length > 0) {
                            __tnt.subscription.offers.locationInputLengths[el.name] = el.value.length;
                        }

                        el.addEventListener('focus', function(ev) {
                            __tnt.subscription.offers.logCheckoutStepViewed({
                                step: __tnt.subscription.offers.getPurchaseStep('location'),
                                label: 'Entering location information'
                            });
                        });

                        el.addEventListener('blur', function(ev) {
                            __tnt.subscription.offers.locationInputLengths[ev.target.name] = ev.target.value.length;

                            if (__tnt.subscription.offers.locationInputsEntered()) {
                                __tnt.subscription.offers.logCheckoutStepCompleted({
                                    step: __tnt.subscription.offers.getPurchaseStep('location'),
                                    label: 'Location information defined'
                                });
                            }
                        });
                    });
                }

                /* Checkout Step - entering the cardholder name */
                pfName = pf.querySelector('input[name="tnpay-name"]');
                if (pfName) {
                    pfName.addEventListener('focus', function(ev) {
                        __tnt.subscription.offers.logCheckoutStepViewed({
                            step: __tnt.subscription.offers.getPurchaseStep('cardholder_name'),
                            label: 'Entering cardholder name',
                            paymentMethod: __tnt.pay.method.newCard.methodString
                        });

                    });

                    pfName.addEventListener('blur', function(ev) {
                        if (pfName.value) {
                            __tnt.subscription.offers.logCheckoutStepCompleted({
                                step: __tnt.subscription.offers.getPurchaseStep('cardholder_name'),
                                label: 'Cardholder name defined',
                                paymentMethod: __tnt.pay.method.newCard.methodString
                            });

                            __tnt.subscription.offers.ccNameLength = pfName.value.length;

                            if (__tnt.subscription.offers.ccInputsEntered()) {
                                __tnt.subscription.offers.logPaymentInfoEntered({
                                    step: __tnt.subscription.offers.getPurchaseStep('payment_info'),
                                    paymentMethod: __tnt.pay.method.newCard.methodString
                                });
                            }
                        }
                    });
                }
            }

            /* Federated Auth Form */
            if (af) {
                afEmail = af.email;

                if (afEmail) {
                    afEmail.addEventListener('focus', function(ev) {
                        __tnt.subscription.offers.logCheckoutStepViewed({
                            step: __tnt.subscription.offers.getPurchaseStep('email'),
                            label: 'Entering email address'
                        });
                    });

                    afEmail.addEventListener('blur', function(ev) {
                        if (afEmail.value) {
                            __tnt.subscription.offers.logCheckoutStepCompleted({
                                step: __tnt.subscription.offers.getPurchaseStep('email'),
                                label: 'Email address defined'
                            });
                        }
                    });
                }
            
                af.addEventListener('submit',function(ev){
                    __tnt.pay.selectedContinueWithEmail(pf, af, tntPay);

                });
            } else {
                __tnt.pay.enableFormForKnownUser(pf, tntPay);

            }

            if(tos && paymentButton && pf){
                tos.addEventListener('change', function(ev){
                    __tnt.pay.tntTosEnableSubmit(pf);
                });
            }

            /* Purchase Specific Init - Happens Every Time */
            pf.addEventListener('tnt-purchase', function(ev){
                var pf = this,
                    afWrapper = null,
                    af = null,
                    errorAlert = null,
                    errorMessage = null;
                
                if (pf && pf.parentElement) {
                    afWrapper = pf.parentElement.querySelector('.tnt-payment-federated-auth');
                    errorAlert = pf.parentElement.querySelector('.tnt-payment-error');
                    errorMessage = pf.parentElement.querySelector('.tnt-payment-message');
                    
                    if (afWrapper) { af = afWrapper.querySelector('form.tnt-payment-federated-auth-form') }
                    if (errorAlert) { errorAlert.hidden = true }
                    if (errorMessage) { errorMessage.hidden = true }
                }
                
                __tnt.pay.clearFederatedAuth(af);
                __tnt.pay.validateForm(pf);
                __tnt.pay.clearPaymentMethod(pf);

                pf.FormInitPromises = [];
                pf.FormScriptPromises = [];

                try {
                    const paymentScripts = JSON.parse(pf.dataset.paymentScripts) || {},
                        paymentOptions = JSON.parse(pf.dataset.paymentOptions) || [];

                    if (paymentOptions && paymentOptions.length) {
                        paymentOptions.forEach((option) => {
                            const scripts = paymentScripts[option];

                            pf.FormScriptPromises.push(new Promise(function(resolve, reject) {
                                window.setTimeout(function(){ resolve(); },500);
                            }) );

                            if (scripts && scripts.length) {
                                scripts.forEach((script) => {
                                    pf.FormScriptPromises.push(new Promise(function(resolve, reject) {
                                        const scriptElements = document.getElementsByTagName('script');
                                        let scriptLoaded = null;

                                        for (let i = 0; i < scriptElements.length; i++) {
                                            if (scriptElements[i].src && scriptElements[i].src == script.src) {
                                                scriptLoaded = scripts[i];
                                                break;
                                            }
                                        }

                                        if (scriptLoaded) {
                                            resolve(scriptLoaded);
                                        } else {
                                            const scriptEl = document.createElement('script');
                                                scriptEl.src = script.src;

                                            if (script.crossorigin) scriptEl.setAttribute('crossorigin',true);

                                            scriptEl.onload = function() {
                                                resolve(script);
                                            };
                                            scriptEl.onerror = function() {
                                                reject(new Error('Script load error for ' + src));
                                            };

                                            document.head.append(scriptEl);
                                        }
                                    }) );
                                });
                            }
                        });
                    }
                } catch(e) { console.log(e) }

                Promise.all(pf.FormScriptPromises).then(function() {
                    if(__tnt.pay.method){
                        var payMethods = Object.keys(__tnt.pay.method);

                        if(payMethods.length){
                             payMethods.forEach(function(method){
                                 if(typeof __tnt.pay.method[method].init == "function"){
                                     __tnt.pay.method[method].init(pf);
                                 }
                             });
                        }
                    }

                    pf.hidden = true;

                    /* All Init Promises Completed */
                    Promise.all(pf.FormInitPromises).then(function() {
                        __tnt.pay.updatePaymentMethodDisplay(pf);

                        var spreedlyLoading = pf.querySelector('.tn-pay-card-loading'),
                            spreedlyWrapper = pf.querySelector('.tn-pay-card-wrapper');

                        if(!af){ __tnt.pay.enableFormForKnownUser(pf, tntPay) }
                        if(spreedlyLoading && spreedlyWrapper){
                            spreedlyLoading.hidden = false;
                            spreedlyWrapper.hidden = true;
                        }

                        if(pf){
                            pf.classList.add('spreedly-initialized');

                            if(spreedlyLoading && spreedlyWrapper){
                                spreedlyLoading.hidden = true;
                                spreedlyWrapper.hidden = false;
                            }

                        } else {
                            if(spreedlyLoading && spreedlyWrapper){
                                spreedlyLoading.hidden = true;
                                spreedlyWrapper.hidden = false;
                            }
                        }

                        if(afWrapper && __tnt.user.authToken == null && !pf.email.value && pf.dataset.authRequired != 'false'){
                            afWrapper.hidden = false;
                            pf.hidden = true;

                        } else if(afWrapper && pf && tntPay) {
                            afWrapper.hidden = true;
                            __tnt.pay.enableFormForKnownUser(pf, tntPay);
                        }

                    });
                });
            });

            /* 
             * Form Submit
             */
            pf.addEventListener('submit', function(ev){
                ev.preventDefault();

                var paymentMethod = 'newCard',
                    invalidFields = {},
                    sError = "";

                if(pf){
                    if(__tnt.user.authToken != null || pf.dataset.purchaseType == "gift"){
                        if (pf.email) pf.email.required = false;
                        if (pf.password) pf.password.required = false;
                        if (pf.password_verify) pf.password_verify.required = false;
                    }
                    if (pf.classList.contains('has-form-validation')) invalidFields = pf.querySelectorAll('[required]:invalid');
                    if (pf.dataset.paymentMethod) paymentMethod = pf.dataset.paymentMethod;

                    /* Payment Method Submit Handler */
                    if (!invalidFields.length && paymentMethod && __tnt.pay.method[paymentMethod] && typeof __tnt.pay.method[paymentMethod].submitPayment == "function") {
                        __tnt.pay.method[paymentMethod].submitPayment(pf);
                    } else {
                        // if form has invalid inputs, validate to display errors
                        $(pf).validate().form();
                    }
                }

                return false;
            });

            /*
             * Payment Success
             */
            pf.addEventListener('tnt-payment-success', function(ev){
                __tnt.user.loginSuccess = true;
                __tnt.user.purchasedAccess = true;
                    
                if (__tnt.user && typeof __tnt.user.updateLoggedIn == "function") {
                    __tnt.user.updateLoggedIn();
                } else if (__tnt.user && typeof __tnt.user.update == "function") {
                    __tnt.user.update();
                }
            });

            /*
             * Payment Error
             */
            pf.addEventListener('tnt-payment-error', function(ev){
                var pf = this,
                    errorAlert = null,
                    errorAlertMessage = null,
                    errorButton = document.createElement('a'),
                    forgotText = null,
                    siteNameEl = document.head.querySelector('meta[property="og:site_name"]'),
                    siteName = "";

                if (pf) { errorAlert = pf.parentElement.querySelector('.tnt-payment-error') }
                if (siteNameEl) { siteName = siteNameEl.content }

                if(errorAlert){
                    errorAlertMessage = errorAlert.querySelector('.error-message');

                    if(ev.detail && ev.detail.message){
                        if (errorAlertMessage && ev.detail.message) { errorAlertMessage.innerHTML = ev.detail.message }
                        if (ev.detail.message == "Invalid password or account does not exist") {

                            if(errorAlertMessage){
                                forgotText = errorAlertMessage.dataset.forgotText;

                                if(forgotText){ errorButton.innerHTML = forgotText }
                            } else {
                                errorButton.innerHTML = "Forgot your password?";
                            }
                            errorButton.classList.add("alert-link", "btn-block");
                            errorButton.href = "javascript:void(0)";
                            errorButton.addEventListener('click',function(ev){
                                var modal = document.getElementById('access-offers-modal'),
                                    modalTabForgot = document.getElementById('user-modal-tab-forgot');

                                __tnt.subscription.access.showTab(modalTabForgot, modal);
                            });

                            errorAlertMessage.appendChild(errorButton);
                        }

                        errorAlert.hidden = false;
                        errorAlert.classList.remove('fade');
                        errorAlert.scrollIntoView(false);
                    }
                }

                if (pf && siteName && ev.detail.requires_confirmation && ev.detail.resolved_rate) {
                    pf.elements.accept_transition.value = 1;

                    var serviceId = pf.dataset.serviceId,
                        serviceName = pf.dataset.serviceName,
                        rateId = ev.detail.resolved_rate.id,
                        rateName = ev.detail.resolved_rate.name,
                        ratePrice = ev.detail.resolved_rate.price,
                        currency = pf.dataset.currency,
                        logData = [],
                        offerGroup = {'name':"Transition",'id':rateId,'offers':[]},
                        productData = {},
                        purchaseTab = pf,
                        zipInput = null,
                        countrySelect = null,
                        rateEl = document.getElementById('user-purchase-rate'),
                        previewMode = false;

                    if (pf) {
                        zipInput = pf['postal-postcode'];
                        countrySelect = pf['postal-country'];
                        if (pf['rate_price']) pf['rate_price'].value = (ratePrice/100);
                        if (pf.dataset.preview == "true") previewMode = true;
                    }

                    /* 
                     * Initialize Product Data
                     */
                    try {
                        productData = __tnt.subscription.offers.getProduct();
                    } catch (e) { console.warn(e); }

                    /*
                     * Format Resolved Rate as Offer
                     */
                    resolvedOffer = {
                        "id": rateId,
                        "service_id": serviceId,
                        "rate_id": rateId,
                        "title": rateName,
                        "description": ev.detail.message,
                        "rate": null,
                        "image": "",
                        "limits": "",
                        "billing_cycle": null,
                        "savings": "",
                        "featured": 0,
                        "featured_message": "",
                        "button_text": "Subscribe",
                        "link_url": window.location.href,
                        "link_js": "",
                        "enabled": 1,
                        "start_date": null,
                        "end_date": null,
                        "service_name": productData.name,
                        "rate_name": rateName,
                        "rate_price": ratePrice, // unformatted
                        "rate_duration": pf.dataset.rateDuration,
                        "rate_currency": currency
                    }
                    offerGroup.offers.push(resolvedOffer);

                    /*
                     * Update Product data
                     */
                    productData.sku = resolvedOffer.rateId;
                    productData.price =  Number(resolvedOffer.rate_price) / 100;
                    productData.variant = resolvedOffer.title;
                    productData.image_url = "";

                    try {
                        productData = __tnt.subscription.offers.setProduct(productData);
                    } catch (e) { console.warn(e); }

                    __tnt.subscription.offers.purchaseDetails(resolvedOffer, siteName, serviceName, serviceId, rateId, rateEl, rateName, purchaseTab, pf, previewMode, productData, true);

                    if (!resolvedOffer.rate_duration) {
                        resolvedOffer.rate_duration = Number(pf.dataset.rateDuration);
                        resolvedOffer.billing_cycle = "Every " + pf.dataset.rateDuration + " days";
                        resolvedOffer.rate = "$" + Number(ratePrice)/100 + " for " + pf.dataset.rateDuration + " days";
                    }

                    /*
                     * Log updated impression
                     */
                    logData.push({
                        impressionData: {
                            'id': resolvedOffer.id,
                            'name': resolvedOffer.service_name,
                            'price': Number(resolvedOffer.rate_price) / 100,
                            'variant': resolvedOffer.rate,
                            'brand': siteName,
                            'category': 'subscription',
                            'list': productData.legacy_context,
                            'variant': resolvedOffer.title,
                            'position': 0
                        },
                        offerData: resolvedOffer,
                        offerGroupId: offerGroup.id,
                        offerGroupName: offerGroup.name,
                        offerContext: "resolved",
                        paywallDisplay: 'modal',
                        productData: productData
                    });
                    __tnt.subscription.offers.logImpression(logData);
                }
            });


            /*
             * Update Purhcase Form base on User Status
             */
            window.addEventListener('tnt-user-status',function(ev){
                var tntPaymentWrapper = document.querySelectorAll('.tnt-payment');

                if(tntPaymentWrapper){
                    tntPaymentWrapper.forEach(function(tntPay){
                        var pf = tntPay.querySelector('form.tnt-payment-form'),
                            afWrapper = tntPay.querySelector('form.tnt-payment-federated-auth'),
                            pfLogin = null;

                        if (pf) {
                            pfLogin = pf.querySelector('.tnt-purchase-login');

                            if(__tnt.user.authToken == null){
                                pf.classList.add("not-logged-in-form-disabled");

                                if (pf.email) pf.email.required = true;
                                if (pf.password) pf.password.required = true;
                                if (pf.password_verify) pf.password_verify.required = true;
                            } else {
                                if (pf.email) pf.email.required = false;
                                if (pf.password) pf.password.required = false;
                                if (pf.password_verify) pf.password_verify.required = false;

                                __tnt.pay.enableFormForKnownUser(pf, tntPay);
                            }
                        }
                    });
                }
            });

        }); // End TNT Payment Wrapper Loop
    }

});
